// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1EOPw","glitch":"style_glitch__2m1Gl","glitch-animation-1":"style_glitch-animation-1__2B6Jm","glitch-animation-2":"style_glitch-animation-2__2O4lh"};